module.exports = __webpack_public_path__ + "static/soc1-dfd1050eab1924058f21d5a57bf57c0d.png";